// @react
import React, { ReactElement } from 'react'
// @typings
import { CommunicationFormValues } from 'modules/common/forms/types/communication'
// @libraries
import { UseFormMethods, Control, useWatch, Controller } from 'react-hook-form'
import { makeStyles } from '@material-ui/core/styles'
import RadioGroup from '@material-ui/core/RadioGroup'
// @components
import InputRadio from '@bit/atd.web.forms.input-radio'
import colors from '@bit/atd.web.colors/dist/colors'
import strings from 'lib/constants/strings'

const useStyles = makeStyles(() => ({
  optionItem: {
    padding: '12px 24px 24px',
    borderBottom: `1px solid ${colors.gray300}`,
    '&:last-child': {
      borderBottom: 'none',
    },
    '& > div': {
      width: '100%',
    },
  },
}))

type PropsType = {
  formMethods: UseFormMethods<CommunicationFormValues>
  control: Control<CommunicationFormValues>
  isEditing: boolean
}

const PostalOptionFields = ({
  formMethods,
  control,
  isEditing,
}: PropsType): ReactElement => {
  /****************************************
   *  HOOKS
   ****************************************/

  const classes = useStyles()
  const watchPostalMail = useWatch<CommunicationFormValues>({
    control,
    name: ['isPostalMailOptedOut'],
  })

  /****************************************
   *  RENDER
   ****************************************/

  return (
    <>
      <RadioGroup name="isPostalMailOptedOutGroup">
        {/* Yes */}
        <div className={classes.optionItem}>
          <InputRadio
            disabled={!isEditing}
            label={strings.ONBOARDING.COMMUNICATION.OPTION_POSTAL_NONE}
            labelPlacement="right"
            size="medium"
            checked={watchPostalMail.isPostalMailOptedOut}
            onChange={() => {
              formMethods.setValue('isPostalMailOptedOut', true, {
                shouldValidate: false,
                shouldDirty: true,
              })
            }}
          />
        </div>

        {/* No */}
        <div className={classes.optionItem}>
          <InputRadio
            disabled={!isEditing}
            label={strings.ONBOARDING.COMMUNICATION.OPTION_POSTAL_GET}
            labelPlacement="right"
            size="medium"
            checked={!watchPostalMail.isPostalMailOptedOut}
            onChange={() => {
              formMethods.setValue('isPostalMailOptedOut', false, {
                shouldValidate: false,
                shouldDirty: true,
              })
            }}
          />
        </div>
      </RadioGroup>

      <Controller
        control={control}
        name="isPostalMailOptedOut"
        render={({ onChange, onBlur, value, name }) => (
          <input
            hidden
            name={name}
            value={value}
            onBlur={onBlur}
            onChange={onChange}
            type="text"
          />
        )}
      />
    </>
  )
}

export default PostalOptionFields
